import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import { DialogActions, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { showAlert } from 'lib/functions/utils';
import { deleteTag } from 'lib/api/tags';

const DeleteTag = (props: any) => {
  const { open, onClose, tag, setUp, category } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleDeleteTag = async () => {
    setLoading(true);
    try {
      await deleteTag(dispatch, tag.id);
      showAlert(dispatch, 'success', 'Tag eliminado correctamente');
      setUp(category.id);
      onClose();
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al eliminar el tag');
    }
    setLoading(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Eliminar Tag</DialogTitle>
        <DialogContent>
          {loading && (
            <div style={{ minHeight: 100 }}>
              <CenteredCircularProgress type="dialog" />
            </div>
          )}
          {!loading && (
            <>
              <Typography>¿Estás seguro de querer eliminar el tag "{tag.name}"?</Typography>
              <Typography>Se eliminaran todos los tags asociados a este tag.</Typography>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <CustomButton
            onClick={onClose}
            color="secondary"
            disabled={loading}
          >
            Cancelar
          </CustomButton>
          <CustomButton
            onClick={handleDeleteTag}
            color="error"
            disabled={loading}
          >
            Eliminar
          </CustomButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteTag;